import { useEffect, useState } from "react";

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    toggleVisibility();
    window.addEventListener("scroll", toggleVisibility, { passive: true });
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll back to top"
      className={`fixed bottom-20 right-4 lg:bottom-8 lg:right-8 z-50 h-12 min-w-[48px] rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 shadow-xl border border-primary-400/30 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-2xl active:translate-y-0 cursor-pointer group flex items-center justify-center ${
        isVisible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <span className="w-12 h-12 flex items-center justify-center flex-shrink-0">
        <i className="ri-arrow-up-line text-xl leading-none transition-transform group-hover:-translate-y-0.5" />
      </span>
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-xs font-semibold tracking-wide transition-all duration-300 group-hover:max-w-xs group-hover:pr-4">
        Back to top
      </span>
    </button>
  );
}
